import { BORDER_COLORS as BC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const UserProfileHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 24px;
    border: 1px solid ${BC.primary};
    border-radius: 8px;
    margin: 24px 0;
`;

export const UserProfileHeaderInfo = styled.div`
    display: flex;
    gap: 16px;
`;

export const UserProfileDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserProfileHeaderInfoAvatar = styled.div<{ $isEditingProfile?: boolean }>`
    position: relative;
    cursor: ${({ $isEditingProfile }) => ($isEditingProfile ? 'pointer' : 'default')};

    img {
        width: 72px;
        height: 72px;
        border-radius: 50%;
    }
`;

export const UserProfileHeaderInfoName = styled.div`
    color: ${TC.heading};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.HEADING_XS].lineHeight};
    ${DESKTOP_SIZES[SIZES.HEADING_LG].fontWeight};
`;

export const UserProfileHeaderInfoItem = styled.div`
    color: ${TC.body};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight};
`;
